import { useLocation } from "react-router-dom";

// page identifier - část za prvním lomítkem v url, např "overview" nebo "fetch-administration"
const useIsPageActive = (pageIdentifier: string) => {
  const { pathname } = useLocation();
  const chunkedPathname = pathname.split("/");

  return pageIdentifier === chunkedPathname[1];
};

export default useIsPageActive;
